import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';
import { Tooltip } from 'bootstrap';

function PosMenuStock() {
	const context = useContext(AppSettings);
	const [time] = useState(getTime());
	const [stockData, setStockData] = useState();
	var tooltip = [];
	
	function checkTime(i) {
		if (i < 10) {i = "0" + i};
		return i;
	}
	
	function getTime() {
		var today = new Date();
		var h = today.getHours();
		var m = today.getMinutes();
		var a;
		m = checkTime(m);
		a = (h > 11) ? 'pm' : 'am';
		h = (h > 12) ? h - 12 : h;
	
		setTimeout(() => {
			getTime();
		}, 500);
		return h + ":" + m + a;
	}
  
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		var elm = document.querySelectorAll('.pos [data-bs-toggle="tooltip"]');
		for (var i = 0; i < elm.length; i++) {
			var t = new Tooltip(elm[i]);
			tooltip.push(t);
		}
		
		fetch('/assets/data/pos/menu-stock.json').then(res => res.json()).then((result) => { setStockData(result); });
		
		return () => {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
			
			if (tooltip) {
				for (var i = 0; i < tooltip.length; i++) {
					tooltip[i].dispose();
				}
			}
			const elements = document.querySelectorAll('.tooltip');
			elements.forEach(el => {
				el.remove();
			});
		};
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div className="pos pos-vertical pos-with-header" id="pos">
			<div className="pos-container">
				<div className="pos-header">
					<div className="logo">
						<Link to="/">
							<div className="logo-img"><Icon icon="material-symbols-light:food-bank" /></div>
							<div className="logo-text">FOOD BANK</div>
						</Link>
					</div>
					<div className="time" id="time">{ time }</div>
					<div className="nav">
						<div className="nav-item">
							<Link to="/pos/counter-checkout" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Counter Checkout" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:shopping-cart-checkout-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/kitchen-order" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Kitchen Order" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:order-approve-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/table-booking" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Table Booking" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:calendar-month-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/menu-stock" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Menu Stock" className="nav-link active">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:inventory-2-outline-sharp" />
								</div>
							</Link>
						</div>
					</div>
				</div>
				<div className="pos-content">
					<div className="pos-content-container p-1px">
						<div className="row g-0">
							{stockData && stockData.length > 0 ? (stockData.map((stock, index) => (
								<div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 p-1px" key={stock.id}>
									<div className="pos-product">
										<div className="img" style={{backgroundImage: 'url('+ stock.image +')'}}></div>
										<div className="info">
											<div className="title text-truncate">{stock.title}</div>
											<div className="desc text-truncate">{stock.description}</div>
											<div className="d-flex align-items-center mb-3">
												<div className="w-80px">Stock:</div>
												<div className="flex-1">
													<input type="text" className="form-control form-control-sm w-50px" defaultValue={stock.stock} />
												</div>
											</div>
											<div className="d-flex align-items-center mb-3">
												<div className="w-80px">Availability:</div>
												<div className="flex-1">
													<div className="form-check form-switch">
														<input className="form-check-input" type="checkbox" name="qty" id="product1" defaultChecked={stock.available} defaultValue="1" />
														<label className="form-check-label" htmlFor="product1"></label>
													</div>
												</div>
											</div>
											<div className="d-flex">
												<a href="#/" className="btn btn-sm btn-secondary d-block flex-1">CANCEL</a>
												<span className="w-10px"></span>
												<a href="#/" className="btn btn-sm btn-theme d-block flex-1">UPDATE</a>
											</div>
										</div>
									</div>
								</div>
							))) : (
								<div className="col-12 p-1px">
									No records found
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PosMenuStock;